import { render, staticRenderFns } from "./CheckoutCart.vue?vue&type=template&id=022ccf55"
import script from "./CheckoutCart.vue?vue&type=script&lang=js"
export * from "./CheckoutCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports